import React, { memo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Marker, FeatureGroup } from 'react-leaflet'
import { innerPosition } from 'Components/Map/InnerMap/innerPosition'
import { icones } from 'Resources/Icons/iconsLeaflet'
import CustomTooltip from 'Utils/components/CustomTooltip'
import { setTrue } from 'Store/actions/toggle-action'
import { updateWiP } from 'Store/actions/modules-action'

//import { setCurrentStatsBar } from 'Store/actions/system-action'
//import { useCanAccess } from 'Utils/rbac'

/*  Author: Bruno Melo
    Type: Smart
	  Description: Render Marker from References
    To do list: 
    - 			
*/

export const RenderCreationMarker = ({ wip, color = 'red' }) => {
  const lat = wip?.geoJson?.geometry?.coordinates[1]
  const lng = wip?.geoJson?.geometry?.coordinates[0]
  let geoJson = wip?.geoJson
  const tooltipText = wip['form-name']
  const typeId = wip['form-type']
  const typeData = useSelector((state) => state.modules.types?.byId[parseInt(typeId)]?.info)
  const dispatch = useDispatch()
  const inner = useSelector((state) => state.toggle.showInnerMap)
  const currentInner = useSelector((state) => state.indoor.current?.inner)

  const markerClick = () => {
    dispatch(setTrue('showStatsBar'))
    //alert('Aqui eu mudo para o modo de edição ')
  }

  const dragEnd = (data) => {
    geoJson.geometry.coordinates[1] = data.target._latlng.lat
    geoJson.geometry.coordinates[0] = data.target._latlng.lng
    dispatch(
      updateWiP({
        moduleType: 'refs',
        geoJson: geoJson,
      })
    )
  }

  //const canAccess = useCanAccess('WRITE')

  let position = inner
    ? innerPosition([lng, lat], 'ref', currentInner?.center, currentInner?.bearing)
    : { lat: lat, lng: lng }

  return (
    <FeatureGroup key={'refFeatureGroupCreationMode'} onClick={() => markerClick()}>
      <Marker
        key={'RenderCreationMarker'}
        position={position}
        icon={icones({
          color: typeData?.color ? typeData.color : 'blue',
          icon: typeData?.icon ? typeData.icon : null,
        })}
        draggable={true}
        ondragend={dragEnd}
      >
        {tooltipText && (
          <CustomTooltip permanent direction="bottom">
            {tooltipText}
          </CustomTooltip>
        )}
      </Marker>
    </FeatureGroup>
  )
}

export default memo(RenderCreationMarker)
